import React from "react";
import HeaderTwo from "../header/HeaderTwo";
import Footer from "../footer/Footer";
import Breadcrumb from "../../widgets/breadcrumb/Breadcrumb";
import { useLocation } from "react-router-dom";
// import { useAppDispatch } from "../../redux/hooks";
// import { getUser } from "../../redux_apis/redux_login/thunk";
// import { getCategories } from "../../redux_apis/redux_categories/thunk";
// import { getAllProducts } from "../../redux_apis/redux_products/thunk";

const LayoutWrapper = ({ children, search = false }) => {
  // const dispatch = useAppDispatch();
  const location = useLocation();

const isDesigner =
  location.pathname === "/designer" ||
  location.pathname === "/designeradmin";

  // useEffect(() => {
  //   dispatch(getUser());
  //   dispatch(getCategories());
  //   dispatch(getAllProducts());
  // }, []);

  return (
    <div className={isDesigner ? "layout-wrapper designer-layout-wrapper" : "layout-wrapper"}>
      {/* 🟢 If designer → Only HeaderTool */}
      {isDesigner ? (
        <>
        
          <main>{children}</main>
          <Footer />
        </>
      ) : (
        /* 🟢 For all other pages → Full layout */
        <>
          <HeaderTwo />
      
          <Breadcrumb search={search} />
          <main>{children}</main>
          <Footer />
        </>
      )}
    </div>
  );
};

export default LayoutWrapper;
